/*
 * Object for handling last-location feature
 * Initialize in main.js, if needed
 */

import FetchHelpers from "../fetch-helpers";

/**
 * Object that represents the last location (virtual section a user was on when they navigated away from a book).
 * @param options
 * @constructor
 */
function LastLocation(options) {
    const { url} = options;
    let l = this;
    l.fetchData = new FetchHelpers().fetchData;

    l.initialize = function() {
    }

  /**
   * Save the user's last location information for the current book
   * @returns {Promise<*>}
   * @param data
   */
    l.save = async function(data) {
       let result = await l.fetchData('POST', url, data);
       if(result.success) {
         console.log(`Successfully updated Last Location: ${result['id']}`);
       } else {
           console.log(`Error updating Last Location ${result['id']}.`);
           // js log?
       }

       return result;
    }

  l.refresh = async function(data) {
    let result = await l.fetchData('POST', url, data);
    if(result.success) {
      console.log(`Successfully refreshed the table contents for paginator ${data['paginatorName']}`);
    } else {
      console.log(`Error refreshing the table contents for paginator ${data['paginatorName']}.`);
      // js log?
    }

    return result;
  }
}

export { LastLocation };
